import React, {lazy, useEffect} from 'react';
import {Route, useLocation, useNavigate} from 'react-router-dom';


import hasRole from '../contexts/Auth/hooks/hasRole';

import PrivateRouteContext from './PrivateRouteContext';
import RootRoutes from './RootRoutes';
import {authConstants, useIsAuthenticated} from '../contexts/Auth';
import {buyConstants} from '../modules/Buy';
import {cartConstants} from '../contexts/Cart';
import {myConstants} from '../contexts/My';
import {orderConstants} from '../contexts/Order';
import {paymentConstants} from '../contexts/Payment';
import {registrationConstants} from '../modules/Registration';

const BuyPages = lazy(() => import('../modules/Buy/pages'));
const CartPages = lazy(() => import('../modules/Cart/pages'));
const MyPages = lazy(() => import('../modules/My/pages'));
const OrderPages = lazy(() => import('../modules/Order/pages'));
const PaymentPages = lazy(() => import('../modules/Payment/pages'));
const RegistrationCustomerPages = lazy(() => import('../modules/Registration/pages/customer'));


const PrivateRoot = function PrivateRoot() {

    const isAuthenticated = useIsAuthenticated();
    const {pathname} = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated && pathname === '/') {
            navigate(buyConstants.NAV_BUY_OVERVIEW_PAGE);
        }
    }, [pathname]);

    const hasCartFeature = hasRole(authConstants.ROLE_FEATURE_CART);
    const hasSearchFeature = hasRole(authConstants.ROLE_FEATURE_SEARCH);
    const hasOrderSubmissionFeature = hasRole(authConstants.ROLE_FEATURE_ORDER_SUBMISSION);

    return (
        <RootRoutes>

            <Route
                element={(
                    <PrivateRouteContext>
                        <RegistrationCustomerPages/>
                    </PrivateRouteContext>
                )}
                path={`${registrationConstants.NAV_REGISTRATION_CUSTOMER_BASE}/*`}
            />

            <Route
                element={(
                    <PrivateRouteContext canAccess={hasSearchFeature}>
                        <BuyPages/>
                    </PrivateRouteContext>
                )}
                path={`${buyConstants.NAV_BUY_OVERVIEW_PAGE}/*`}
            />

            <Route
                element={(
                    <PrivateRouteContext canAccess={hasCartFeature}>
                        <CartPages/>
                    </PrivateRouteContext>
                )}
                path={`${cartConstants.NAV_PAGE_CART}/*`}
            />

            <Route
                element={(
                    <PrivateRouteContext canAccess={hasOrderSubmissionFeature}>
                        <OrderPages/>
                    </PrivateRouteContext>
                )}
                path={`${orderConstants.NAV_ORDERS_BASE}/*`}
            />

            <Route
                element={(
                    <PrivateRouteContext canAccess={hasOrderSubmissionFeature}>
                        <PaymentPages/>
                    </PrivateRouteContext>
                )}
                path={`${paymentConstants.NAV_PAYMENT_BASE}/*`}
            />

            <Route
                element={(
                    <PrivateRouteContext>
                        <MyPages/>
                    </PrivateRouteContext>
                )}
                path={`${myConstants.NAV_MY_BASE}/*`}
            />

        </RootRoutes>
    );
};


export default PrivateRoot;
